/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_PaidInputs */



/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Payment_PaidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_paid = /** @type {((inputs?: Payment_PaidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_PaidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Payé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pagado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pago")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagato")
	return /** @type {LocalizedString} */ ("Paid")
});